// Costanti CRM Contatti WhatsApp (allineate a backend/crm_contacts.py)
export const CATEGORIES = [
  { value: "cliente", label: "Cliente", cls: "bg-sky-500/15 text-sky-700 dark:text-sky-300" },
  { value: "rivenditore", label: "Rivenditore", cls: "bg-brand/15 text-brand" },
  { value: "ambassador", label: "Ambassador", cls: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300" },
  { value: "media", label: "Media", cls: "bg-violet-500/15 text-violet-700 dark:text-violet-300" },
  { value: "altro", label: "Altro / Da classificare", cls: "bg-slate-500/15 text-slate-700 dark:text-slate-300" },
];
export const INTERESTS = [
  { value: "moto", label: "Moto" },
  { value: "mtb", label: "MTB" },
  { value: "gravel", label: "Gravel" },
  { value: "archivio1969", label: "Archivio 1969" },
];
export const STATUSES = [
  { value: "nuovo", label: "Nuovo" },
  { value: "attivo", label: "Attivo" },
  { value: "da_ricontattare", label: "Da ricontattare" },
  { value: "non_interessato", label: "Non interessato" },
  { value: "chiuso", label: "Chiuso" },
];
export const CONSENT_SOURCES = [
  { value: "whatsapp", label: "Messaggio WhatsApp" },
  { value: "email", label: "E-mail" },
  { value: "modulo", label: "Modulo / Form" },
  { value: "verbale", label: "Verbale / Telefono" },
  { value: "import", label: "Import" },
  { value: "altro", label: "Altro" },
];
export const TYPE_LABEL = { lead: "Rivenditore", user: "Rivenditore B2B", ambassador: "Ambassador", media: "Testata", wa_contact: "Contatto WhatsApp" };
export const BASE_BY_TYPE = { lead: "rivenditore", user: "rivenditore", ambassador: "ambassador", media: "media", wa_contact: "altro" };

export const catOf = (v) => CATEGORIES.find((c) => c.value === v) || CATEGORIES[4];
export const labelOf = (list, v) => (list.find((x) => x.value === v) || {}).label || v || "—";
export const fmtDate = (iso) => { try { return iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—"; } catch { return "—"; } };

export const consentInfo = (c) => {
  const s = c?.status || "none";
  if (s === "granted") return { label: "Consenso attivo", cls: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300", detail: `${labelOf(CONSENT_SOURCES, c.source)} · ${fmtDate(c.granted_at)}` };
  if (s === "revoked") return { label: "Revocato", cls: "bg-red-500/15 text-red-700 dark:text-red-300", detail: `${c.revoke_source === "opt-out messaggio" ? "Opt-out ricevuto" : labelOf(CONSENT_SOURCES, c.revoke_source) || "Manuale"} · ${fmtDate(c.revoked_at)}` };
  return { label: "Nessun consenso", cls: "bg-slate-500/15 text-slate-700 dark:text-slate-300", detail: "Non presunto: va registrato esplicitamente" };
};
